import React from 'react';
interface MonogramProps {
  className?: string;
}
export function Monogram({
  className = ''
}: MonogramProps) {
  return <span aria-hidden="true" className={`inline-flex h-9 w-9 items-center justify-center rounded-full border border-charcoal/80 font-display text-[13px] italic tracking-tight text-charcoal ${className}`} data-id="element-36" data-mp="3m9ubyn66g681">
      0x
    </span>;
}